import SearchContent from './SearchContent.jsx';

export default SearchContent;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/index.js